import apiClient from './apiClient';

export class UserService {

  /**
   * @summary Get the current user
   * @returns {Promise<{
   *   username: "user@domain.com",
   *   clientID: 123,
   *   clientName: "Client Name"
   *   canAccessClients: {
   *     clientID: 123,
   *     clientName: "Client Name"
   *   }[]
   * }>}
   */
  async getUser() {
    const response = await apiClient.getWithCache("api/user", { cacheDuration: 1000 * 60 * 60 });
    return response.data;
  }
}  